import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Meses } from '@shared/enums/Meses';
import { ResolucionMensual } from '@shared/models/cierreTurno/ResolucionMensual';
import { MessageService } from '@shell/message.service';
import { ReportesService } from '../../reportes.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VisorInformeResolucionComponent } from './visor-informe-resolucion/visor-informe-resolucion.component';
import { ModalGenerarResolucionComponent } from './modal-generar-resolucion/modal-generar-resolucion.component';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { ModalJustificacionResolucionComponent } from './modal-justificacion-resolucion/modal-justificacion-resolucion.component';
import { UsuarioService } from '@account/usuario.service';
import { CierreTurnoService } from '@cierreTurno/cierre-turno.service';
import { TipoAeroplanta } from '@shared/enums/TipoAeroplanta';
import { Aeroplanta } from '@shared/models/cierreTurno/Aeroplanta';
import { ProductoService } from '@abm/producto/producto.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AuthService } from '@authentication/auth.service';
import { environment } from '@environments';

@Component({
  selector: 'app-resolucion-mensual',
  templateUrl: './resolucion-mensual.component.html',
  styleUrls: ['./resolucion-mensual.component.scss']
})
export class ResolucionMensualComponent implements OnInit {

  fechaDesde: Date;
  fechaHasta: Date;

  TipoUsuario = TipoUsuario;
  meses = Meses;
  cargandoAeroplantas: boolean;
  productos;
  mostrarTabla: boolean = false;
  contadorAeroplanta: string;
  resoluciones: ResolucionMensual[] = [];
  aeroplantasGeneradas: string[] = [];
  aeroplantasFiltradas = [];
  cargandoResolucion: boolean = false;
  busqueda: UntypedFormGroup;
  obteniendoResolucion: boolean;
  generada: boolean = false;
  resolucionMensual: ResolucionMensual = new ResolucionMensual();
  aeroplantas: Aeroplanta[];
  aeroplantasSeleccionadas: any[];
  aeroplantasAJustificar;
  puedeGenerarse: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private modal: NgbModal,
    private reportesService: ReportesService,
    private productosService: ProductoService,
    private excelService: ExportExcelServiceService,
    private cierreTurnoService: CierreTurnoService,
    private usuarioService: UsuarioService,
    public authService: AuthService
  ) {
    const fecha = new Date();
    this.busqueda = this.fb.group({
      mesesFormControl: [null, Validators.required],
      anioFormControl: [fecha.getFullYear(), Validators.required]
    });
  }

  ngOnInit(): void {
    this.obtenerAeroplantas();
    this.obtenerProductos();
  }

  obtenerAeroplantas() {
    const aeroplantasAFiltrar = ['TDL', 'JNI', 'ENO', 'DTO', 'CUT', 'SCL', 'SCE'];
    this.cargandoAeroplantas = true;
    this.cierreTurnoService.getAeroplantas3()
      .subscribe(a=>{
        this.aeroplantas = a.sort((a,b) => {{ if (a.nombre > b.nombre) { return 1 } else { return -1 } }});
        this.aeroplantas = this.aeroplantas.filter(a => !aeroplantasAFiltrar.includes(a.codigo));
        this.aeroplantas.forEach(aeroplanta => aeroplanta.seleccionada = false);
        this.cargandoAeroplantas = false;
      }, ()=>{
        this.cargandoAeroplantas = false;
      });
  }

  async obtenerProductos() {
    this.productos = await this.productosService.obtenerProductosPromise();
    this.productos = this.productos.filter(p => p.rubro.aerocombustible || p.rubro.combustible).filter(p => p.activo);
  }

  async obtenerResolucion() {
    this.mostrarLoading();
    this.resolucionMensual.renglonesResolucion = [];
    this.aeroplantasGeneradas = [];
    this.mostrarTabla = true;
  
    /*const aeroplantaEzeiza = this.aeroplantasFiltradas.some(a => a.codigo === 'EZE');
    const aeroplantaAeroparque = this.aeroplantasFiltradas.some(a => a.codigo === 'AEP');
    if((aeroplantaEzeiza && aeroplantaAeroparque) || (aeroplantaEzeiza && this.aeroplantasFiltradas.length > 1) || (aeroplantaAeroparque && this.aeroplantasFiltradas.length > 1)) {
      this.puedeGenerarse = false;
    } else this.puedeGenerarse = true;*/

    this.puedeGenerarse = this.aeroplantasTercera || (this.aeroplantasFiltradas.every(a => a.tipoAeroplanta === TipoAeroplanta.Propias) && this.aeroplantasFiltradas.length==1);

    for await (const a of this.aeroplantasFiltradas) {
      try {
        const resolucion = await this.reportesService.obtenerResolucionMensual(a.codigo, this.getFechaDesde(this.mesesFormControl.value), this.getFechaHasta(this.mesesFormControl.value));
        this.resoluciones.push(resolucion);
        this.resolucionMensual.ano = resolucion.ano;
        this.resolucionMensual.mes = resolucion.mes;
        this.resolucionMensual.generada = resolucion.generada;
        if(resolucion.generada) this.aeroplantasGeneradas.push(resolucion.renglonesResolucion[0].codigoAeroplanta)
        this.resolucionMensual.renglonesResolucion = this.resolucionMensual.renglonesResolucion.concat(resolucion.renglonesResolucion);
        this.chequearPermisos(this.resolucionMensual.renglonesResolucion);
      } catch(e) {
        //this.messageService.showErrorMessage(e.description);
        continue;
      }
    }

    if (this.resolucionMensual.renglonesResolucion.length > 0) {
      this.completarTotales();
    }

    this.ocultarLoading();
  }



  chequearPermisos(renglones) {
    
    const dni = this.usuarioService.getDniOperador();
    let ultima;
    let aeroplanta;
    const renglonesResolucion = [];
    for (const renglon of renglones) {
      if (ultima !== renglon.codigoAeroplanta) {
        aeroplanta = this.aeroplantas.find(a => a.codigo == renglon.codigoAeroplanta);
        ultima = renglon.codigoAeroplanta
      }
     
      if (aeroplanta.responsable) {
        if ((aeroplanta.responsable.dni == dni || aeroplanta.sustituto.dni == dni)) {
          renglon.puedeAceptar = true;
          renglonesResolucion.push(renglon);     
        } else {
          renglon.puedeAceptar = false;
          renglonesResolucion.push(renglon); 
        } 
      }
      this.resolucionMensual.renglonesResolucion = renglonesResolucion;

    }
  }

  keysMeses(): Array<string> {
    let keys = Object.keys(this.meses);
    keys = keys.slice(keys.length / 2);
    return keys;
  }

  getFechaDesde(mes: number) {
    const yyyy = this.anioFormControl.value;
    const mm = Number(this.meses[mes]);
    const fdesde = new Date(yyyy, mm, 1);
    return this.formatDate(yyyy, mm, fdesde.getDate(), 0, 0, 0);
  }

  getFechaHasta(mes: number) {
    const yyyy = this.anioFormControl.value;
    const mm = Number(this.meses[mes]);
    const fhasta = new Date(yyyy, mm, 0);
    return this.formatDate(yyyy, mm, fhasta.getDate(), 23, 59, 59);
  }

  formatDate(year, month, day, hour, minute, seconds): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 });
  }

  mostrarLoading() {
    this.cargandoResolucion = true;
    this.spinner.show('spinnerGrafico');
  }

  ocultarLoading() {
    this.cargandoResolucion = false;
    this.spinner.hide('spinnerGrafico');
  }

  completarTotales() {
    for (const item of this.resolucionMensual.renglonesResolucion) {
      item.porcentual = item.porcentual ? item.porcentual : 0;
      item.nombreProducto = this.productos.find(p=>p.codigoProducto==item.codigoProducto).nombreProducto;
    }
    this.resolucionMensual?.renglonesResolucion.sort((a, b) => {
      if (a.codigoAeroplanta < b.codigoAeroplanta) {
        return -1;
      } else if (a.codigoAeroplanta > b.codigoAeroplanta) {
        return 1;
      } else {
        return a.nombreProducto.localeCompare(b.nombreProducto);
      }
    });
  }

  filtrarMovimientos() {
    this.mostrarLoading();
    this.aeroplantasFiltradas = this.aeroplantas.filter(aeroplanta => aeroplanta.seleccionada);
    if(this.aeroplantasFiltradas.length == 0) {
      this.messageService.showErrorMessage('No hay aeroplantas seleccionadas');
      this.ocultarLoading();
      return;
    } else this.obtenerResolucion();
  }

  generarResolucion() {
    const modalRef = this.modal.open(ModalGenerarResolucionComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.codigoAeroplanta = this.resolucionMensual.renglonesResolucion[0].codigoAeroplanta;
    modalRef.componentInstance.fdesde = this.getFechaDesde(this.mesesFormControl.value);
    modalRef.componentInstance.fhasta = this.getFechaHasta(this.mesesFormControl.value);
    modalRef.componentInstance.productos = this.productos;
    modalRef.componentInstance.esTercera = this.aeroplantasTercera;    
    modalRef.result.then(recargar => {
      if (!recargar) this.obtenerResolucion()
    });
  }

  async verResolucion() {
    const nombreResolucion =  this.aeroplantasTercera ? 'TERCERAS' : this.resolucionMensual.renglonesResolucion[0].codigoAeroplanta;
    if(this.aeroplantasTercera) {
      this.seleccionarTerceras(true);
      this.filtrarMovimientos();
      await this.obtenerResolucion();
    }
    const modalRef = this.modal.open(VisorInformeResolucionComponent, { centered: true, size: 'xl', backdrop: 'static', keyboard: false });
    modalRef.componentInstance.esTercera = this.aeroplantasTercera;
    modalRef.componentInstance.resoluciones = this.resolucionMensual;
    modalRef.componentInstance.fileName = `Resolución_${nombreResolucion}_${this.resolucionMensual.mes}/${this.resolucionMensual.ano}.pdf`;
  }

  abrirModalJustificacion(renglon) {
    const modalRef = this.modal.open(ModalJustificacionResolucionComponent, { centered: true, size: 'm', backdrop: 'static', keyboard: false });
    modalRef.componentInstance.renglon = renglon;
    modalRef.componentInstance.fecha = this.getFechaHasta(this.mesesFormControl.value);
    modalRef.componentInstance.nombreResponsable = this.usuarioService.getNombresOperador();
  }

  seleccionarTerceras(e) {
    this.aeroplantas.forEach(a => {
      e && (a.tipoAeroplanta == TipoAeroplanta.Terceras) ? a.seleccionada = true : a.seleccionada = false;
    }) 
  }

  exportarExcel() {
    const length = this.resolucionMensual.renglonesResolucion.length;
    const json = []
    for (let i = 0; i < length; i++) {
      const renglon = this.resolucionMensual.renglonesResolucion[i];
      json.push({
        "Codigo Dependencia": renglon.codigoAeroplanta,
        "Dependencia": renglon.nombreAeroplanta,
        "Producto": renglon.codigoProducto,
        "Fecha Ult. Cierre": renglon.fechaUltimoCierre,
        "Existencia Inicial": renglon.existenciaInicial,
        "Entradas": renglon.entradas,
        "Salidas": renglon.salidas,
        "Existencia Libros": renglon.existenciaLibros,
        "Existencia Final": renglon.existenciaFinal,
        "Removido": renglon.removido,
        "Sup/Def [lt]": renglon.diferencia,
        "Porcentual": renglon.porcentual.toFixed(3) + "%",
        "Tolerancia": renglon.toleranciaMensualOperativa && renglon.resultadoTolerancia !== null ? renglon.toleranciaMensualOperativa.toFixed(3) + "%" : "Error",
        "Resultado": renglon.toleranciaMensualOperativa && renglon.resultadoTolerancia !== null ? renglon.resultado : "Error",
        "% FT": renglon.toleranciaMensualOperativa && renglon.resultadoTolerancia !== null ? renglon.resultadoTolerancia.toFixed(2) + "%" : "Error",
        "Justificacion": renglon.justificacion
      })
    }

    this.excelService.exportAsExcelFile(json, "resolucion " + this.resolucionMensual.mes + "/" + this.resolucionMensual.ano);
  }

  get aeroplantasTercera() {
    return this.aeroplantasFiltradas.every(a => a.tipoAeroplanta === TipoAeroplanta.Terceras);
  }

  get mesesFormControl() {
    return this.busqueda.controls.mesesFormControl;
  }

  get anioFormControl() {
    return this.busqueda.controls.anioFormControl;
  }

  get inProduction(): boolean {
    return environment.name === 'production';
  }
}
